module.exports = __webpack_public_path__ + "img/rmm.78b5b4f9.png";